const AGENT_BOILERPLATE_PATTERNS = [
  /^fix this\b/i,
  /investigation findings\s*:/i,
  /let me produce the structured findings/i,
  /based on my (extensive )?investigation/i,
];

export const looksLikeAgentTranscript = (text) => {
  const normalized = (text || "").trim();
  if (!normalized) {
    return false;
  }
  return AGENT_BOILERPLATE_PATTERNS.some((pattern) => pattern.test(normalized));
};
